"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ARRAY_PARENT_SIGMA_MODEL_TYPES = void 0;
exports.parseSubModelId = parseSubModelId;
exports.isArrayParentSigmaModel = isArrayParentSigmaModel;
exports.getArrayElementConfig = getArrayElementConfig;
exports.arrayParentForElement = arrayParentForElement;
exports.composeArraySignalName = composeArraySignalName;
exports.buildArraySubModels = buildArraySubModels;
exports.extractArraySubmodelPrefix = extractArraySubmodelPrefix;
const SUBMODEL_ID_PATTERN = /^([A-Z]+)[-_]?(\d+)$/;
function parseSubModelId(subModelId) {
    const match = SUBMODEL_ID_PATTERN.exec(subModelId);
    if (match?.[1] === undefined || match[2] === undefined) {
        return null;
    }
    return { prefix: match[1], ordinal: Number.parseInt(match[2], 10) };
}
exports.ARRAY_PARENT_SIGMA_MODEL_TYPES = {
    passiveArray: 'passive.array',
    icGeneric: 'ic.generic',
};
function isArrayParentSigmaModel(sigmaModelType) {
    return Object.values(exports.ARRAY_PARENT_SIGMA_MODEL_TYPES).includes(sigmaModelType);
}
function getArrayElementConfig(elementModelType) {
    switch (elementModelType) {
        case 'resistor.standard':
        case 'resistor.variable':
            return { prefix: 'R', parentType: exports.ARRAY_PARENT_SIGMA_MODEL_TYPES.passiveArray };
        case 'resistor.thermistor':
            return { prefix: 'RT', parentType: exports.ARRAY_PARENT_SIGMA_MODEL_TYPES.passiveArray };
        case 'resistor.varistor':
            return { prefix: 'RV', parentType: exports.ARRAY_PARENT_SIGMA_MODEL_TYPES.passiveArray };
        case 'capacitor.nonpolarized':
        case 'capacitor.polarized':
            return { prefix: 'C', parentType: exports.ARRAY_PARENT_SIGMA_MODEL_TYPES.passiveArray };
        case 'diode.generic':
        case 'diode.zener':
        case 'diode.led':
        case 'diode.tvs.bidirectional':
        case 'diode.tvs.unidirectional':
            return { prefix: 'D', parentType: exports.ARRAY_PARENT_SIGMA_MODEL_TYPES.passiveArray };
        case 'ferrite.standard':
            return { prefix: 'FB', parentType: exports.ARRAY_PARENT_SIGMA_MODEL_TYPES.passiveArray };
        case 'fuse.generic':
        case 'fuse.poly':
            return { prefix: 'F', parentType: exports.ARRAY_PARENT_SIGMA_MODEL_TYPES.passiveArray };
        case 'inductor.standard':
            return { prefix: 'L', parentType: exports.ARRAY_PARENT_SIGMA_MODEL_TYPES.passiveArray };
        case 'mosfet.enhancement.ntype':
        case 'mosfet.enhancement.ptype':
        case 'transistor.bjt.npn':
        case 'transistor.bjt.pnp':
            return { prefix: 'Q', parentType: exports.ARRAY_PARENT_SIGMA_MODEL_TYPES.icGeneric };
        default:
            return null;
    }
}
function arrayParentForElement(elementModelType) {
    return getArrayElementConfig(elementModelType)?.parentType ?? null;
}
function composeArraySignalName(submodelId, signalName) {
    return `${submodelId}_${signalName}`;
}
function buildArraySignalConnectionMap(submodelId, elementModelSignals, signalsByName) {
    const connectionMap = [];
    for (const elementSignal of elementModelSignals) {
        const compositeSignal = signalsByName.get(composeArraySignalName(submodelId, elementSignal.name));
        if (compositeSignal === undefined) {
            continue;
        }
        connectionMap.push({
            componentSignalId: String(compositeSignal.id),
            modelSignalId: elementSignal.id,
        });
    }
    return connectionMap;
}
function buildArraySubModels(args) {
    const signalsByName = new Map(args.signals.map((signal) => [signal.name, { id: signal.id, name: signal.name }]));
    const parameterMap = args.parameterMap ?? {};
    const submodels = [];
    for (let index = 1; index <= args.elementCount; index += 1) {
        const subModelId = `${args.submodelPrefix}${index}`;
        submodels.push({
            type: 'sigma',
            subModelId,
            modelId: args.elementModelId,
            modelInfo: {
                signalConnectionMap: buildArraySignalConnectionMap(subModelId, args.elementModelSignals, signalsByName),
                parameterMap: { ...parameterMap },
            },
        });
    }
    return submodels;
}
function extractArraySubmodelPrefix(submodelIds) {
    if (submodelIds.length === 0) {
        return { isValid: false, reason: 'No submodel IDs provided' };
    }
    const parsed = [];
    const invalidIds = [];
    for (const submodelId of submodelIds) {
        const ref = parseSubModelId(submodelId);
        if (ref === null) {
            invalidIds.push(submodelId);
            continue;
        }
        parsed.push({ prefix: ref.prefix, index: ref.ordinal });
    }
    if (invalidIds.length > 0) {
        return { isValid: false, reason: `Invalid submodel ID format: ${invalidIds.join(', ')}` };
    }
    const prefixes = new Set(parsed.map((entry) => entry.prefix));
    if (prefixes.size !== 1) {
        return { isValid: false, reason: `Mixed submodel prefixes found: ${[...prefixes].join(', ')}` };
    }
    const sortedIndices = parsed.map((entry) => entry.index).sort((left, right) => left - right);
    if (!sortedIndices.every((index, position) => index === position + 1)) {
        return {
            isValid: false,
            reason: `Submodel numbers are not sequential starting from 1: ${sortedIndices.join(', ')}`,
        };
    }
    const [prefix] = [...prefixes];
    return { isValid: true, prefix };
}
//# sourceMappingURL=array-submodels.js.map